export class LocationMiscellaneousCertificationModel {
    id?: string | null = null;
    locationId?: string | null = null;
    // Apparatus fields
    // apparatusModelNo?: string | null = null;
    // apparatusManufaturer?: string | null = null;
    // apparatusSerialNo?: string | null = null;
    // apparatusCertNo?: string | null = null;

    apparatusUoV?: string | null = null;
    apparatusIoMa?: string | null = null;
    apparatusPoW?: string | null = null;
    apparatusCouF?: string | null = null;
    apparatusLoMh?: string | null = null;

    // Cable fields
    // cableManfacturer?: string | null = null;
    // cableModelNo?: string | null = null;
    // cableSerialNo?: string | null = null;
    // cableCertNo?: string | null = null;
    cableCMuF?: string | null = null;
    cableLengthM1?: string | null = null;
    cableCCuF?: string | null = null;
    cableLmMh?: string | null = null;
    cableLengthM2?: string | null = null;
    cableCLMh?: string | null = null;
    cableLrcMhOHM?: string | null = null;
    cableLRoMhOHM?: string | null = null;

    // Continuity and Equipment fields
    // continuityOHM?: string | null = null;
    // continuityOHM2?: string | null = null;
    // equipmentScreenOHM?: string | null = null;
    // equipmentScreenOHM2?: string | null = null;

    // Current Transformer (ExeCurrentTransformer)
    exEshortCircuitCurrent?: string | null = null;

    // General Purpose Junction Box (ExeGeneralPurposeJunctionBox)
    exEGmaxRatedPower?: string | null = null;
    exEGarrangedMethod?: string | null = null;
    exEGterminalSize?: string | null = null;
    exEGpermissibleConductorNumber?: string | null = null;
    exEGpermissibleConductorSize?: string | null = null;
    exEGmaxCurrent?: string | null = null;

    // Protection Type Ex p (ExPInformation)
    exPminPurgeFlow?: string | null = null;
    exPminPurgeDurartion?: string | null = null;
    exPtypeOfProtectiveGas?: string | null = null;
    exPminOverpressure?: string | null = null;
    exPmaxOverpressure?: string | null = null;
    exPminSupplyPressure?: string | null = null;
    exPmaxSupplyPressure?: string | null = null;
    exPmaxLeakageRate?: string | null = null;
    exPrangeOfTemprature?: string | null = null;
    exPpointsOfPressure?: string | null = null;
    exPinternalSourceOfRelease?: string | null = null;
    exPmaxInletPressure?: string | null = null;
    exPmaxFlowRate?: string | null = null;

    // Field fields
    // fieldManufacturer?: string | null = null;
    // fieldModelNo?: string | null = null;
    // fieldSerialNo?: string | null = null;
    // fieldCertNo?: string | null = null;
    fieldUiV?: string | null = null;
    fieldIiMa?: string | null = null;
    fieldPiW?: string | null = null;
    fieldCiuF?: string | null = null;
    fieldLiMh?: string | null = null;

    // Motor(Rotating Electric Machine) (MotorRotatingElectricMachine)
    mOperatedConvertor?: string | null = null;
    mSpeedRangeLimitLow?: string | null = null;
    mSpeedRangeLimitHigh?: string | null = null;
    mFrequencyRangeLimitLow?: string | null = null;
    mFrequencyRangeLimitHigh?: string | null = null;
    mSwitchingFrequency?: string | null = null;
    mSwitchingFrequencyUnit?: string | null = null;
    mTypeOfTorque?: string | null = null;
    mSpecificConverter?: string | null = null;
    mTypeOfConverter?: string | null = null;
    mExEbMotor?: string | null = null;
    mIaIn?: string | null = null;
    mTeS?: string | null = null;

    // Multi Core Screen
    // multiCoreScreenOHM?: string | null = null;

    created?: Date | null = null;
    updated?: Date | null = null;

    constructor(data?: Partial<LocationMiscellaneousCertificationModel>) {
        Object.assign(this, data);
    }
}
